import react, { useState, useEffect, useMemo } from 'react';
import './Filtros.scss'
import DropdownButton from '../../../../../components/moleculesv2/DropdownButton/DropdownButton';
import Area from '../formularios/Area';
import Proyecto from '../formularios/Proyecto';
import Sprint from '../formularios/Sprint';
import Tarea from '../formularios/Tarea';
import OptionsGroup from '../../../../../components/moleculesv2/OptionsGroup/OptionsGroup';
import MultiSelect from '../../../../../components/Atomsv2/MultiSelect/MultiSelect';
import Calendar from '../../../../../components/Atomsv2/Calendar/Calendar';
import Button from '../../../../../components/Atomsv2/Button/Button';

const Filtros = ({ data, setData, vista, setVista, filtros, setFiltros }) => {

    const [area, setArea] = useState(false)
    const [proyecto, setProyecto] = useState(false)
    const [sprint, setSprint] = useState(false)
    const [tarea, setTarea] = useState(false)
    const [mostrarFiltros, setMostrarFiltros] = useState(true)

    const estatusFiltros = useMemo(() => data.estatus || [], [data.estatus]);
    const prioridadFiltros = useMemo(() => data.prioridades || [], [data.prioridades]);
    const areaFiltros = useMemo(() => data.area || [], [data.area]);
    const proyectoFiltros = useMemo(() => data.proyecto || [], [data.proyecto]);
    const sprintFiltros = useMemo(() => data.sprints || [], [data.sprints]);
    const usuarioFiltros = useMemo(() => {
        const usuarios = data.usuario || [];
        const idsConTarea = new Set(
            (data.tareas || []).map(t => t.USUARIO_ASIGNADO_ID).filter(Boolean)
        );
        return usuarios.filter(u => idsConTarea.has(u.value ?? u.ID));
    }, [data.usuario, data.tareas]);


    const getId = (item) => item?.ID ?? item?.value;
    const normalizarTexto = (text) =>
        String(text || '')
            .normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toUpperCase();

    const estatusDefault = useMemo(() => {
        const estatusActivos = estatusFiltros.filter((item) => {
            const nombre = normalizarTexto(item?.ESTATUS ?? item?.name ?? item?.label);
            return !nombre.includes('PAUS') && !nombre.includes('CANCEL');
        });

        return estatusActivos.length > 0 ? estatusActivos : estatusFiltros;
    }, [estatusFiltros]);

    const syncSelection = (allItems = [], selectedItems = []) => {
        if (!Array.isArray(allItems) || allItems.length === 0) {
            return [];
        }

        if (!Array.isArray(selectedItems) || selectedItems.length === 0) {
            return allItems;
        }

        const allowedIds = new Set(allItems.map(getId));
        const validSelected = selectedItems.filter((item) =>
            allowedIds.has(getId(item))
        );

        return validSelected.length > 0 ? validSelected : allItems;
    };

    useEffect(() => {
        setFiltros((prev) => {
            const estatusSeleccionados =
                Array.isArray(prev.estatus) && prev.estatus.length > 0
                    ? syncSelection(estatusFiltros, prev.estatus)
                    : estatusDefault;
            return {
                ...prev,
                estatus: estatusSeleccionados,
                prioridades: syncSelection(prioridadFiltros, prev.prioridades),
                areas: syncSelection(areaFiltros, prev.areas),
                proyectos: syncSelection(proyectoFiltros, prev.proyectos),
                sprints: syncSelection(sprintFiltros, prev.sprints),
                usuarios: syncSelection(usuarioFiltros, prev.usuarios ?? []),
            };
        });
    }, [
        estatusFiltros,
        estatusDefault,
        prioridadFiltros,
        areaFiltros,
        proyectoFiltros,
        sprintFiltros,
        usuarioFiltros,
    ]);

    const handleFiltroChange = (key) => (e) =>
        setFiltros(prev => ({ ...prev, [key]: e }));

    const acciones = [
        { icono: "crop_square", title: "Área", onClick: () => setArea(true) },
        { icono: "folder", title: "Proyecto", onClick: () => setProyecto(true) },
        { icono: "sprint", title: "Sprint", onClick: () => setSprint(true) },
        { icono: "add_task", title: "Tarea", onClick: () => setTarea(true) },
    ]
    const opciones = [
        { value: 'tabla', label: 'Tabla' },
        { value: 'kanban', label: 'Kanban' },
        { value: 'gantt', label: 'Gantt' },
    ]
    return (
        <div className='Filtros'>
            <div className='proyecto-nuevo'>
                <OptionsGroup style={{ width: '260px' }} className={"proyecto-pestañas"} options={opciones} activeValue={vista} onSelect={(e) => setVista(e)}></OptionsGroup>
                <div style={{ display: "flex", alignItems: "center",gap:"10px" }}>
                    <Button
                        icon={mostrarFiltros ? 'filter_alt_off' : 'filter_alt'}
                        variant='ghost'
                        onClick={() => setMostrarFiltros(v => !v)}
                    >
                        {mostrarFiltros ? 'Ocultar filtros' : 'Mostrar filtros'}
                    </Button>
                    <DropdownButton label='Categorías' items={acciones}></DropdownButton>
                </div>
            </div>
            <div className='proyecto-filtros'>
                {mostrarFiltros && (
                    <>
                        <MultiSelect
                            label={"Usuario"}
                            options={usuarioFiltros}
                            value={filtros.usuarios}
                            onChange={handleFiltroChange('usuarios')}
                            mapper={{ name: "label", value: "value" }}
                        />
                        <MultiSelect
                            label={"Estatus"}
                            options={estatusFiltros}
                            value={filtros.estatus}
                            onChange={handleFiltroChange('estatus')}
                            mapper={{ name: "ESTATUS", value: "ID" }}
                        />
                        <MultiSelect
                            label={"Area"}
                            options={areaFiltros}
                            value={filtros.areas}
                            onChange={handleFiltroChange('areas')}
                            mapper={{ name: "AREA", value: "ID" }}
                        />
                        <MultiSelect
                            label={"Proyecto"}
                            options={proyectoFiltros}
                            value={filtros.proyectos}
                            onChange={handleFiltroChange('proyectos')}
                            mapper={{ name: "PROYECTO", value: "ID" }}
                        />
                        <MultiSelect
                            label={"Sprint"}
                            options={sprintFiltros}
                            value={filtros.sprints}
                            onChange={handleFiltroChange('sprints')}
                            mapper={{ name: "SPRINT", value: "ID" }}
                        />

                        <MultiSelect
                            label={"Prioridad"}
                            options={prioridadFiltros}
                            value={filtros.prioridades}
                            onChange={handleFiltroChange('prioridades')}
                            mapper={{ name: "PRIORIDAD", value: "ID" }}
                        />

                        <Calendar value={filtros.fechaIni}
                            onChange={(e) => { setFiltros(prev => ({ ...prev, fechaIni: e })) }}
                            label='Fecha inicio'></Calendar>
                        <Calendar value={filtros.fechaFin}
                            onChange={(e) => { setFiltros(prev => ({ ...prev, fechaFin: e })) }}
                            label='Fecha fin'></Calendar>
                    </>
                )}

            </div>
            <Area data={data} setData={setData} open={area} onClose={() => setArea(false)}></Area>
            <Proyecto data={data} setData={setData} open={proyecto} onClose={() => setProyecto(false)}></Proyecto>
            <Sprint data={data} setData={setData} open={sprint} onClose={() => setSprint(false)}></Sprint>
            <Tarea data={data} setData={setData} open={tarea} onClose={() => setTarea(false)}></Tarea>
        </div>
    )
}
export default Filtros